import Alpine from "alpinejs";

Alpine.store('sectionId', {
    sections: [],
    activeSection: "",
    intersectedSections: [],
    anchorList: [],
    isEntered: false,
    addSection(sectionId) {
        if (!this.sections.includes(sectionId)) {
            this.sections.push(sectionId);
        }    
    },
    removeSection(sectionId) {
        this.sections = this.sections.filter((id) => id !== sectionId);
    },
    addIntersectSection(sectionId) {
        if (this.anchorList.length === 0 || this.anchorList.find(anchor => anchor == sectionId)) {
            this.activeSection = sectionId;
            const intersectedSections = this.intersectedSections.filter((id) => id !== sectionId);
            this.intersectedSections = [...intersectedSections, sectionId];
        }
    },
    setActiveSection(sectionId) {
        this.activeSection = sectionId;
    },
    getLastIntersectSection(anchorList) {
        if (this.anchorList.length === 0) {
            this.anchorList = anchorList;
        }
        return this.intersectedSections.slice().reverse().find(item => this.anchorList.includes(item));
    }
});